import { Outlet,Navigate } from "react-router-dom";
import axios from "axios";
import { useState, useEffect, use } from "react";
import { useAuth } from "./Auth";


let user;

const ProtectedRoutes = () => {
    const auth = useAuth();
    
    user = auth.user;
    return user ? <Outlet/> : <Navigate to="/login"/>
}

export default ProtectedRoutes